"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
function defaultQueryArgs() {
    return {};
}
exports.defaultQueryArgs = defaultQueryArgs;
function matchNameZh(query, queryArg, node) {
    return (node.nameZh || "").toString().indexOf(query) > -1;
}
exports.matchNameZh = matchNameZh;
function matchNamePyAbbr(query, queryArg, node) {
    if (query.length < 2) {
        return false;
    }
    return (node.namePyAbbr || "").toString().indexOf(query) == 0;
}
exports.matchNamePyAbbr = matchNamePyAbbr;
function matchNamePy(query, queryArg, node) {
    if (query.length < 3) {
        return false;
    }
    return (node.namePyJoined || "").toString().indexOf(query) == 0;
}
exports.matchNamePy = matchNamePy;
function doSearch(query, queryArgs, store) {
    query = query.trim().toLowerCase();
    return (0, _keys2.default)(store.allNodesSet).filter(function (nid) {
        var node = store.allNodesSet[nid];
        if (queryArgs.ofCountry) {
            if (node.ofCountry !== queryArgs.ofCountry) {
                return false;
            }
        }
        var doMatch = function doMatch(matcher) {
            return matcher(query, queryArgs, node);
        };
        return doMatch(matchNameZh) || doMatch(matchNamePyAbbr) || doMatch(matchNamePy);
    });
}
exports.doSearch = doSearch;
//# sourceMappingURL=search-util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/search-util.js
// module id = 553
// module chunks = 0